/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { comboCalculationItemRequestSchema } from "./comboCalculationItemRequestSchema.ts";

export const comboCalculationGroupRequestSchema = z.object({
	id: z.uuid(),
	item: comboCalculationItemRequestSchema,
});
